import React from 'react'

interface IcDoneProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcDone: React.FC<IcDoneProps> = ({
  width = '16px',
  height = '16px',
  color = '#10BF79',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, ...style }}
      color={color}
      {...props}
    >
      <g clipPath="url(#clip0_16187_969)">
        <path
          d="M5.77779 8.49999L7.25927 9.98148L10.2222 7.01851M14.6667 8.49999C14.6667 12.1819 11.6819 15.1667 8.00001 15.1667C4.31811 15.1667 1.33334 12.1819 1.33334 8.49999C1.33334 4.8181 4.31811 1.83333 8.00001 1.83333C11.6819 1.83333 14.6667 4.8181 14.6667 8.49999Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16187_969">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IcDone
